import React from 'react';
import { Toaster as SonnerToaster, ToasterProps as SonnerToasterProps } from 'sonner';
import { LoadingSpinner } from './LoadingSpinner';
import { CheckIcon, ErrorIcon } from './icons/ValidationIcons';

const config: SonnerToasterProps = {
  position: 'bottom-right',
  visibleToasts: 10,
  swipeDirections: ['left', 'right'],
  icons: {
    loading: <LoadingSpinner size={13} color="skyblue" borderWidth={2} />,
    success: <CheckIcon height={16} width={16} />,
    error: <ErrorIcon height={16} width={16} />,
  },
  style: {
    fontFamily: 'Poppins, system-ui, -apple-system, "Segoe UI", roboto, "Helvetica Neue", arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  },
};

export function Toaster(props: SonnerToasterProps) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <SonnerToaster {...config} {...props} />;
}
